import moment from 'moment';
import * as React from 'react';
import SelectTimeframe, { StatsPeriod } from '../../../../../../common/components/SelectTimeframe/SelectTimeframe';
import { convertPeriodToOption } from '../../../../../../common/datetime';
import { DeveloperGameStatsAnalytics } from '../../Games/userDeveloperSubmission-graphql';
import { Submission } from '../submission-graphql';
import DeveloperSubmissionStatsDailyBar from './DeveloperSubmissionStatsDailyBar';
import DeveloperSubmissionStatsHeader from './DeveloperSubmissionStatsHeader';
import { CustomSelect } from '../../../../../../common/Styleguide/Common/Select';
import { Option } from '@mui/base';

interface IDeveloperSubmissionStatsProps {
  submission: Submission;
}

export type DeveloperSubmissionStatsMetric = keyof DeveloperGameStatsAnalytics | 'revenue';

// 'all' is treated as null on graph, perhaps this can be addressed at some point
export type ClientStatsDeviceFilter = 'desktop' | 'mobile' | 'all';
const period = 'LAST_6_MONTHS';
const DEFAULT_TIMEFRAME: StatsPeriod = { period, preDefinedTimeframe: true, options: convertPeriodToOption(period) };

const DeveloperSubmissionStats: React.FunctionComponent<IDeveloperSubmissionStatsProps> = ({ submission }) => {
  const [timeframeFilter, setTimeframeFilter] = React.useState<StatsPeriod>(DEFAULT_TIMEFRAME);
  const [selectedMetric, setSelectedMetric] = React.useState<DeveloperSubmissionStatsMetric>('pageviews');
  const [deviceFilter, setDeviceFilter] = React.useState<ClientStatsDeviceFilter>('all');

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
        <CustomSelect
          style={{ height: 40, width: 200 }}
          value={deviceFilter}
          onChange={(_evt, value) => setDeviceFilter(value as ClientStatsDeviceFilter)}
        >
          <Option value={'all'}>All</Option>
          <Option value={'desktop'}>Desktop</Option>
          <Option value={'mobile'}>Mobile</Option>
        </CustomSelect>
        <SelectTimeframe
          minDate={moment.utc('2023-09-01').endOf('day')}
          maxDate={moment.utc()}
          hideLabel
          initialPeriod={timeframeFilter.period}
          onChange={(newTimeframe) => setTimeframeFilter(newTimeframe)}
        />
      </div>
      <DeveloperSubmissionStatsHeader
        submission={submission}
        deviceFilter={deviceFilter}
        timeframeFilter={timeframeFilter}
        selectedMetric={selectedMetric}
        onMetricClick={setSelectedMetric}
      />
      <DeveloperSubmissionStatsDailyBar
        deviceFilter={deviceFilter}
        timeframeFilter={timeframeFilter}
        submission={submission}
        selectedMetric={selectedMetric}
      />
    </>
  );
};

export default DeveloperSubmissionStats;
